<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-datepicker inline title="Дата" v-bind="$form.input('date')" />
        <n-input title="Границы участка, км, пк" v-bind="$form.input('border')" />
        <n-input title="Температура воздуха °С" v-bind="$form.input('airTemp')" />
        <n-input title="Изоляция: вид (п.бр. и т.д.) т и п (У, Н) конструкция (1 1, 1 2, 2 2 и т.п.)" v-bind="$form.input('isolation1')" />
        <n-input title="Изоляция: Марка клея (Праймера) и марка изоляционной ленты, к-во слоев" v-bind="$form.input('isolation2')" />
        <n-input title="Изоляция: Марка оберточного материала, к-во слоев" v-bind="$form.input('isolation3')" />
        <n-input title="Изоляция: Сведения о производственном контроле качества выполняемых работ: метод контроля" v-bind="$form.input('isolation4')" />
        <n-input title="Укладка и балластировка: Сведения о производственном контроле укладки трубопровода на проектные отметки: проектные отметки верха трубы после укладки" v-bind="$form.input('placing1')" />
        <n-input title="Укладка и балластировка: Сведения о производственном контроле укладки трубопровода на проектные отметки: фактические отметки верха трубы после укладки" v-bind="$form.input('placing2')" />
        <n-input title="Укладка и балластировка: Границы участка балластировки от км (пк) до км (пк)" v-bind="$form.input('placing6')" />
        <n-input title="Укладка и балластировка: Тип, вес балластировочных устройств, удерживающая способность анкерных устройств" v-bind="$form.input('placing7')" />
        <n-input title="Укладка и балластировка: Шаг пригрузки" v-bind="$form.input('placing8')" />
        <n-input title="Примечания" v-bind="$form.input('remark')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
